import React, { useState, useEffect } from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import { connect } from 'react-redux';
import { goToPage, setTitle, getCategory, setSelectedCategory, pageLoaded, setArabicFirstFolderCategory } from '../fundialSlice';
import CategoriesList from '../Shared/CategoriesList/CategoriesList';
import Gallery from '../Shared/Gallery/Gallery';
import { showAppLoader, hideAppLoader } from '../../../Shared/Loader/LoaderSlice';
import Search from '../Shared/Search/search';
import DownloadSongPopUp from '../Shared/DownloadSongPopUp/DownloadSongPopUp'

const CatalogPage = (props) => {

  useExtendedEffect((runSideEffects) => { 
    window.scrollTo(0, 0);
    if (runSideEffects()) {
      props.setTitle({ titleBold: "קטלוג שירים", titleRegular: "" });
      async function getCatalog() {
        props.showAppLoader();
        let categories = await props.getCategory(0);
        if(categories.payload.errorCode == 0){
          await Promise.all(categories.payload.results.folders.map(category => { if((!category.description.includes("ערבית") && props.catagories[category.id] == undefined)) props.getCategory(category.id)} ));
          await getArabicCategory(categories.payload.results);
        }
        props.hideAppLoader(); 
        props.pageLoaded();
     } 
     getCatalog();
    }
  }, []);

  async function getArabicCategory(categories){
    let arabicCategory = categories.folders.find( category => category.description.includes("ערבית"));
    if(arabicCategory && props.catagories[arabicCategory.id] == undefined){
    let arabicCategoryData = await props.getCategory(arabicCategory.id);
    if( arabicCategoryData.payload.errorCode == 0 && arabicCategoryData.payload.results.folders.length > 0 ){
      let arabicFirstCategory = arabicCategoryData.payload.results.folders[0];
      let arabicCategoryFolderData = await props.getCategory(arabicFirstCategory.id);
        if(arabicCategoryFolderData.payload.errorCode == 0 && arabicCategoryFolderData.payload.results.items.length > 0 ){
          props.setArabicFirstFolderCategory({id: arabicFirstCategory.id, description: arabicCategory.description + " " + arabicFirstCategory.description });
        }
      }
    }
  }

  async function getCategory(categoryId, categoryTitle, goToNextPage) {
    props.showAppLoader();
    var category = await  props.getCategory(categoryId);
    props.hideAppLoader();  
    if(goToNextPage && category.payload.errorCode == 0){
      setNextPage(categoryId, categoryTitle, category.payload.results.folders.length > 0);
    }
  }

  function setNextPage(categoryId, categoryTitle , isFolder ){
    if(isFolder){
      props.setSelectedCategory({id: categoryId, title: categoryTitle, page: "categoryPage" });
      props.goToPage({page: 'categoryPage'});
    }
    else{
      props.setSelectedCategory({id: categoryId, title: categoryTitle, page: "songListPage" });
      props.goToPage({page: 'songListPage'});
    }
  }

  function handleOnClickCategory(categoryId, categoryTitle) {
    if(props.catagories[categoryId]){
      setNextPage(categoryId, categoryTitle, props.catagories[categoryId].isFolders);
    }
    else{
      getCategory(categoryId, categoryTitle, true);
    }  
  }

  function view(){
      return(<div>
                <Search></Search>
                { 
                  props.catagories[0]?.folders.map((category, index ) => {
                  if(index < 2 && props.catagories[category.id]){
                    if(!props.catagories[category.id].isFolders && props.catagories[category.id]?.items?.length > 0){
                      return (<><Gallery categoryId={category.id} title={category.description} subTitle="לכל השירים" items={props.catagories[category.id].items} /><br /></>)
                    }
                  }
                })}
                {props.catagories[0] && <><Gallery categoryId={0} items={props.catagories[0].folders} isCategories={true} onClickCategory={handleOnClickCategory} /></>}
                { 
                  props.catagories[0]?.folders.map((category, index ) => {
                  if(index > 1 && props.catagories[category.id]) {
                    if( !props.catagories[category.id].isFolders && props.catagories[category.id]?.items?.length > 0){
                      return (<><Gallery categoryId={category.id} title={category.description} subTitle="לכל השירים" items={props.catagories[category.id].items} /><br /></>)
                    }
                  }
                })}
                { props.arabicFirstFolderCategory &&
                  <><Gallery categoryId={props.arabicFirstFolderCategory.id} title={props.arabicFirstFolderCategory.description} subTitle="לכל השירים" items={props.catagories[props.arabicFirstFolderCategory.id].items} /><br/></>
                }
                {props.catagories[0] && <CategoriesList onClickCategory={handleOnClickCategory} items={props.catagories[0].folders} title="כל הקטגוריות" />

                }
                <DownloadSongPopUp  />
            </div>)
  }


  return (
    <div className='catalog-page'>
      {view()}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    catagories: state.fundialPage.catagories,
    isFinishedGetAllCategories : state.fundialPage.pages.catalogPage.isFinishedGetAllCategories,
    arabicFirstFolderCategory: state.fundialPage.pages.catalogPage.arabicFirstFolderCategory
  };
};

const mapDispatchToProps = {
  goToPage,
  setTitle, 
  getCategory, 
  setSelectedCategory,
  pageLoaded,
  showAppLoader, 
  hideAppLoader,
  setArabicFirstFolderCategory
};

export default connect(mapStateToProps, mapDispatchToProps)(CatalogPage);
